"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notice = void 0;
var noticesUrl = '/notices';
exports.notice = function (axios) {
    return {
        // [Notice]
        getNoticePublic: function (getNoticePublicRequest) {
            return axios.get(noticesUrl + "/public", getNoticePublicRequest);
        },
        //notice/public
        getNoticeNoticeNo: function (getNoticePublicNoticeNoRequest) {
            var _a;
            var url = noticesUrl + "/public/" + getNoticePublicNoticeNoRequest.pathParams.noticeNo + "?noticeTarget=" + ((_a = getNoticePublicNoticeNoRequest.params) === null || _a === void 0 ? void 0 : _a.noticeTarget);
            return axios.get(url);
        },
        putNotice: function (putNoticeRequest) {
            return axios.put(noticesUrl, putNoticeRequest.data);
        },
        getNoticeList: function (getNoticeListRequest) {
            return axios.get(noticesUrl, getNoticeListRequest);
        },
        getNoticeByNoticeNo: function (getNoticeByNoticeNoRequest) {
            var url = noticesUrl + "/" + getNoticeByNoticeNoRequest.pathParams.noticeNo;
            return axios.get(url);
        },
        deleteNoticeByNoticeNo: function (deleteNoticeByNoticeNoRequest) {
            return axios.delete(noticesUrl + "?noticeNos=" + deleteNoticeByNoticeNoRequest.pathParams.noticeNos);
        },
        PostNotice: function (postNoticeRequest) {
            return axios.post(noticesUrl, postNoticeRequest.data);
        },
        PutNoticeByNoticeNo: function (putNoticeByNoticeNoRequest) {
            return axios.put(noticesUrl + "/" + putNoticeByNoticeNoRequest.params.noticeNo, putNoticeByNoticeNoRequest.data);
        },
        getNoticesGodo: function () {
            return axios.get('/notices/godo');
        },
        getNoticesCategories: function () {
            return axios.get('/notices/categories');
        }
    };
};
